if (!customElements.get('countdown-promo-timer')) {
  class CountdownPromoTimer extends HTMLElement {
    constructor() {
      super();

      this.intervalId = null;
      this.unitElements = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]'),
      };
    }

    connectedCallback() {
      const endValue = this.dataset.end;

      if (!endValue) {
        return;
      }

      const normalizedEnd = endValue.includes('T') ? endValue : endValue.replace(' ', 'T');
      this.endTime = Date.parse(normalizedEnd);

      if (Number.isNaN(this.endTime)) {
        return;
      }

      this.tick();
      this.intervalId = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
      }
    }

    tick() {
      const remaining = Math.max(0, this.endTime - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.updateUnit('days', days);
      this.updateUnit('hours', hours);
      this.updateUnit('minutes', minutes);
      this.updateUnit('seconds', seconds);

      if (remaining === 0 && this.dataset.hideWhenExpired === 'true') {
        const section = this.closest('.shopify-section');

        if (section) {
          section.style.display = 'none';
        }

        if (this.intervalId) {
          window.clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }
    }

    updateUnit(unit, value) {
      const element = this.unitElements[unit];

      if (element) {
        element.textContent = String(value);
      }
    }
  }

  customElements.define('countdown-promo-timer', CountdownPromoTimer);
}
